<!-- header -->
<app-header></app-header>



<app-sidebar></app-sidebar>

<router-outlet></router-outlet>

 <!-- footer -->
 <app-footer></app-footer>

 <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
 <p-toast></p-toast>